import store from '@/store';

import { Roles } from '@/core/constants/roleConstants';
import { hasAnyRole } from './helpers';

/**
 * Guard for protected routes.
 * - If the user is not authenticated → returns a route location object for the SignIn view.
 * - If the user is authenticated → returns null (navigation continues).
 */
export const authenticated = () => {
  if (!store.getters['auth/authenticated']) {
    return { name: 'SignIn' };
  }
  return null;
};

/**
 * Guard for guest-only routes (e.g., login, register).
 * - If the user is authenticated → returns a route location object for the home view
 * - If the user is not authenticated → returns null (navigation continues).
 */
export const guest = () => {
  if (store.getters['auth/authenticated']) {
    return { name: 'Home' };
  }
  return null;
};

export const notCustomer = () => {
  const roles = store.getters['auth/roles'];

  if (hasAnyRole(roles, [Roles.CUSTOMER_RETAIL, Roles.CUSTOMER_WHOLESALER])) {
    return { name: '403' };
  }

  return null;
};
